import React from 'react';
import { Map } from 'immutable';
import TextEditorTitleWrapper from '../text-editor-title-wrapper';

export default function createBlockRenderMap({ titleTheme }) {
  // eslint-disable-next-line new-cap
  return Map({
    'header-one': {
      element: 'h2',
      wrapper: <TextEditorTitleWrapper theme={titleTheme}/>,
    },
    'header-two': {
      element: 'h3',
      wrapper: <TextEditorTitleWrapper theme={titleTheme}/>,
    },
    'code-block': {
      element: 'div',
    },
  });
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-block-render-map.js